import {
  DOMAIN,
  Header,
  ContentType,
  GetFormData,
  Method,
  http
} from './api-utils';

/**
 * 获取足迹列表
 * @param {*} param0
 */
export const trackMap = async ({ pageSize, pageNum }) => {
  const { data } = await http({
    method: Method.POST,
    url: DOMAIN + '/footprint/list',
    data: {
      page: pageNum,
      size: pageSize
    }
  });

  const { map, totalNum } = data;

  return {
    map,
    totalNum
  };
};

/**
 * 删除足迹
 * @param {*} param0
 */
export const deleteTrack = async ({ id }) => {
  await http({
    method: Method.DELETE,
    url: DOMAIN + '/footprint/del',
    params: {
      id
    }
  });
};

/**
 * 删除某天的足迹
 * @param {*} param0
 */
export const deleteDayTrack = async ({ date }) => {
  await http({
    method: Method.DELETE,
    url: DOMAIN + '/footprint/del/someday',
    params: {
      day: date
    }
  });
};
